export const ModalButtonType = {
    Primary: 1,
    Secondary: 2,
    Danger: 3,
    Link: 4,
    Processing: 5,
    Tertiary: 6,
};

export const ModalButtonAlignment = {
    Left: 1,
    Right: 2
}

export const ModalWidth = {
    Normal: 1,
    Narrow: 2,
    ExtraNarrow: 3,
    Wide: 4,
    ExtraWide: 5
};

export const ModalSidebarItemStatus = {
    None: 0,
    Incomplete: 1,
    Complete: 2,
    Error: 3
};